module.exports = __webpack_public_path__ + "img/Blank.1f314c3f.svg";